export const featured = [
  {
    title: "Authors Real Life Journey (LinkedIn Featured)",
    link: "https://www.linkedin.com/in/dubisetty/details/featured/",
    img: "/images/f1.jpeg"
  },
  {
    title: "Ideal Guru & Knowledge Sharing Professional",
    link: "https://ambitiousmagazine.com/mallikarjuna-rao-dubisetty-an-ideal-guru-and-knowledge-sharing-professional/",
    img: "/images/f2.png"
  },
  {
    title: "Ambitious Magazine Real Life Story & Blog Articles",
    link: "https://ambitiousmagazine.com/mallikarjuna-rao/",
    img: "/images/f3.jpg"
  },
  {
    title: "Indian Achievers Forum",
    link: "https://www.iafindia.com/mr-mallikarjuna-rao-dubisetty/",
    img: "/images/f4.webp"
  },
  {
    title: "Global CxO Network Announcement",
    link: "https://cxolanes.com/exclusive/prof-dr-mallikarjuna-rao-dubisetty-dr-mallick-joins-helixbeat-as-vice-president-strategy-execution-healthcare-life-sciences-website-www-helixbeat-com/",
    img: "/images/f6.png"
  },
  {
    title: "ET CIO News",
    link: "https://cio.economictimes.indiatimes.com/news/corporate-news/transformational-shift-in-network-centric-solutions-hyperscalers-and-career-opportunities/94069163",
    img: "/images/f1.jpeg"
  },
  {
    title: "Architect of Inclusive Innovation in Healthcare (Book)",
    link: "https://magazine.theknowledgereviewmagazine.in/the-5-inspiring-thought-leaders-you-should-know-in-2025-september-2025/#page=23",
    img: "/images/f8.png"
  },
  {
    title: "Architect of Inclusive Innovation in Healthcare (Story)",
    link: "https://theknowledgereviewmagazine.in/mallikarjuna-rao-dubisetty-architect-of-inclusive-innovation-in-healthcare/",
    img: "/images/f9.webp"
  }
];
